$( document ).ready(function() {
  $('.Slider-section .grid').slick({
  centerMode: true,
  autoplay: false,
  centerPadding: '100px',
  slidesToShow: 3,
  prevArrow:"<button type='button' onclick='prev()' id='prev' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='21' height='34' viewBox='0 0 21 34' fill='none'><path d='M20.2031 3.86659L7.06979 16.9999L20.2031 30.1333L16.6698 33.6666L0.00312424 16.9999L16.6698 0.333252L20.2031 3.86659Z' fill='black'/></svg></button>",
  nextArrow:"<button type='button' onclick='next()' id='next' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='21' height='34' viewBox='0 0 21 34' fill='none'><path d='M0.796875 3.86659L13.9302 16.9999L0.796875 30.1333L4.33021 33.6666L20.9969 16.9999L4.33021 0.333252L0.796875 3.86659Z' fill='black'/></svg></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1
      }
    }
  ]
});
 
  
   $('.slider-feature-collection').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<button type='button'  id='prev' class='slick-prev pull-left'><svg xmlns='http://www.w3.org/2000/svg' width='21' height='34' viewBox='0 0 21 34' fill='none'><path d='M20.2031 3.86659L7.06979 16.9999L20.2031 30.1333L16.6698 33.6666L0.00312424 16.9999L16.6698 0.333252L20.2031 3.86659Z' fill='black'/></svg></button>",
  nextArrow:"<button type='button' id='next' class='slick-next pull-right'><svg xmlns='http://www.w3.org/2000/svg' width='21' height='34' viewBox='0 0 21 34' fill='none'><path d='M0.796875 3.86659L13.9302 16.9999L0.796875 30.1333L4.33021 33.6666L20.9969 16.9999L4.33021 0.333252L0.796875 3.86659Z' fill='black'/></svg></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  
});
   